import { forwardRef, type HTMLAttributes } from "react";

import { cn } from "../lib/utils";

/**
 * Loading skeleton. Animation is suppressed when `prefers-reduced-motion`
 * is set — accessibility per KEN_LAYER_7 §7.9.
 *
 * A11y (design intent §G.8): the skeleton placeholder is DECORATIVE — it
 * carries `aria-hidden` so a screen reader never announces the shimmer
 * shapes as content. The *container* that swaps in real content owns
 * `aria-busy="true"` while loading (the loading-state regions in this
 * slice set it explicitly). A prior version put `aria-live="polite"` on
 * the skeleton itself, which made assistive tech announce every pulsing
 * placeholder — the inverse of the intent.
 */
export const Skeleton = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden="true"
      className={cn(
        "rounded-[var(--radius-sm)]",
        "bg-[oklch(90%_0.005_230)] motion-safe:animate-pulse",
        className,
      )}
      {...props}
    />
  ),
);
Skeleton.displayName = "Skeleton";
